// Shared primitive schemas used across the domain model.
import { z } from "zod";
/** An ISO-8601 datetime string (UTC on the wire). The canonical timestamp form at a boundary. */
export const Timestamp = z.iso.datetime();
/** A trimmed, non-empty string. */
export const NonEmptyString = z.string().trim().min(1);
export const Json = z.lazy(() => z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
    z.array(Json),
    z.record(z.string(), Json),
]));
/** A JSON object: a `jsonb` column that is always an object (a prop bag, a payload map). */
export const JsonObject = z.record(z.string(), Json);
//# sourceMappingURL=common.js.map